var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMcIconLrg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mc_icon_lrg",
    "data-name": "Multi Select Icon Large",
    transform: "translate(-6480 -1307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,6a3,3,0,1,0,3,3A3,3,0,0,0,9,6ZM9,3a6,6,0,1,0,6,6A6,6,0,0,0,9,3ZM9,13.8A4.8,4.8,0,1,1,13.8,9,4.8,4.8,0,0,1,9,13.8Z",
    transform: "translate(6477 1304)",
    fill: "#8f6aea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,6a3,3,0,1,0,3,3A3,3,0,0,0,9,6ZM9,3a6,6,0,1,0,6,6A6,6,0,0,0,9,3ZM9,13.8A4.8,4.8,0,1,1,13.8,9,4.8,4.8,0,0,1,9,13.8Z",
    transform: "translate(6490 1317)",
    fill: "#8f6aea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,3a6,6,0,1,0,6,6A6,6,0,0,0,9,3ZM9,13.8A4.8,4.8,0,1,1,13.8,9,4.8,4.8,0,0,1,9,13.8Z",
    transform: "translate(6477 1317)",
    fill: "#8f6aea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,6a3,3,0,1,0,3,3A3,3,0,0,0,9,6ZM9,3a6,6,0,1,0,6,6A6,6,0,0,0,9,3ZM9,13.8A4.8,4.8,0,1,1,13.8,9,4.8,4.8,0,0,1,9,13.8Z",
    transform: "translate(6490 1304)",
    fill: "#8f6aea"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcIconLrg);
export default __webpack_public_path__ + "static/media/mc_icon_lrg.04640a194c2bb1bc2f33a187523f8469.svg";
export { ForwardRef as ReactComponent };